import React, { useEffect, useState, useMemo, useRef, useContext } from "react";
import { Container, Row } from "react-bootstrap";
import ReadNews from "components/newsCard/readNews";
import { useRouter } from "next/router";
//import TrendingToday from "components/common/trendingToday";
import { useDispatch, useSelector } from "react-redux";
import { getAdsBySize } from "redux/actions/ads.Actions";
//import NotFound from "pages/404";
// import Link from "next/link";
import { FormattedMessage } from "react-intl";
//import Script from "next/script";
// import Ads from "../../ad";
import TrendingToday from "components/common/trendingToday";
import { getTrendingPosts } from "redux/actions/postAction";
import { timeSince } from "constants/cardsConstant";

import InfiniteScroll from "react-infinite-scroll-component";
import { baseUrl } from "api/constants";
import { debounce } from "debounce";
import { NoRecordsFoundMessage } from "components/shared/loader/loader";
// import Head from "next/head";
import { NextSeo } from "next-seo";
import Head from "next/head";
import { useWindowSize } from "api/commonConstants";
import HtmlParser from "react-html-parser";
import { removeHtmlTags } from "constants/cardsConstant";
import FAQComponent from "components/faq";
import {
  apstagBidCallback,
  createApsSlotsRosMobile,
  createApsSlotsRosDesktop,
  requestBiddingFromPWT,
} from "./../Ads/index";
import WidgetHome from "components/cricket/WidgetHome";
import { MasterConfigContext } from "constants/MasterConfigContext";

const ActiveTabs = ({ topicData = {}, topicName = "", ramMandirBanner , pointsData , scoreData  , cricketData}) => {
  console.log("ramMandirBanner", topicData);
  //const [recordPerPage, setRecordPerPage] = useState(5);
  const router = useRouter();
  const { query } = router;
  const dispatch = useDispatch();
  const contentRef = useRef(null);
  const [activeTab, setActiveTab] = useState(query.activeTab || "text");
  const masterConfig = useContext(MasterConfigContext);

  // const [hashtagsByType, getHashtagsByType] = useState("text");
  const [hasMore, setHasMore] = useState({
    text: true,
    video: true,
    audio: true,
    shorts: true,
  });
  // const [skipPerPage, setSkipPerPage] = useState({
  //   text: 5,
  //   video: 5,
  //   audio: 5,
  //   shorts: 5,
  // });
  const [skipPerPage, setSkipPerPage] = useState({
    text: 2,
    video: 2,
    audio: 2,
    shorts: 2,
  });
  const [topicCategoryData, setTopicCategoryData] = useState({
    text: topicData?.entity?.textArticles || [],
    video: topicData?.entity?.videoArticles || [],
    audio: topicData?.entity?.audioArticles || [],
    shorts: topicData?.entity?.shortsArticles || [],
  });
  const size = useWindowSize();
  const [threshold, setThreshold] = useState(90);
  useEffect(() => {
    if (size?.width < 400) {
      setThreshold(4);
    } else if (size?.width < 460) {
      setThreshold(4);
    } else if (size?.width < 500) {
      setThreshold(4);
    } else if (size?.width < 550) {
      setThreshold(4);
    } else if (size?.width < 600) {
      setThreshold(3);
    } else if (size?.width < 800) {
      setThreshold(3);
    } else if (size?.width < 1000) {
      setThreshold(3);
    } else if (size?.width < 1200) {
      setThreshold(3);
    } else if (size?.width < 1450) {
      setThreshold(3);
    } else {
      setThreshold(3);
    }
  }, [size]);

  useEffect(() => {
    if (topicData?.entity?.textArticles?.length) {
      setActiveTab("text");
    } else if (topicData?.entity?.videoArticles?.length) {
      setActiveTab("video");
    } else if (topicData?.entity?.audioArticles?.length) {
      setActiveTab("audio");
    } else if (topicData?.entity?.shortsArticles?.length) {
      setActiveTab("shorts");
    }
  }, []);
  const [isClamped, setClamped] = useState(false);
  const [isExpanded, setExpanded] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (contentRef && contentRef.current) {
        setClamped(
          contentRef.current.scrollHeight > contentRef.current.clientHeight
        );
      }
    }, 300);
  }, []);

  const { adPlacement300_600 } = useSelector(({ AdsReducer }) => AdsReducer);

  // const tabName = router.asPath.split("/")[1];
  const { trendingPosts } = useSelector(({ PostReducer }) => PostReducer);

  useEffect(() => {
    dispatch(getTrendingPosts());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAdsBySize());
  }, [dispatch]);

  const getMorePost = debounce(async () => {
    const res = await fetch(
      `${baseUrl}/topicItem/getContentsBySlugAndType?limit=${5}&skip=${
        skipPerPage[activeTab] || 0
      }&slug=${topicData?.entity?.slug}&type=${activeTab}`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      }
    );
    const newPosts = await res.json();

    if (newPosts?.result?.entities?.length > 0) {
      setTopicCategoryData({
        ...topicCategoryData,
        [activeTab]: [
          ...topicCategoryData[activeTab],
          ...newPosts?.result?.entities,
        ],
      });
    } else {
      setHasMore({ ...hasMore, [activeTab]: false });
    }
    // setSkipPerPage({ ...skipPerPage, [activeTab]: skipPerPage["text"] + 10 });
    setSkipPerPage({ ...skipPerPage, [activeTab]: skipPerPage[activeTab] + 1 });

    // } else setLoginPrompt(true);
  }, 1000);
  const [firstScroll, setFirstScroll] = useState(false);
  const [adCalled, setAdCalled] = useState(false);

  useEffect(() => {
    var showAds = true;

    if (process.env.NEXT_PUBLIC_ADS_ONSCROLL === "true" && !firstScroll) {
      showAds = false;
    }
    if (showAds && !adCalled) {
      setAdCalled(true);

      setTimeout(() => {
        window.googletag = window.googletag || { cmd: [] };
        if (window.screen.width > 600) {
          googletag.cmd.push(function () {
            googletag
              .defineSlot(
                "/1007232/Lallantop_Desktop_ROS_ATF_728x90",
                [
                  [728, 90],
                  [970, 250],
                  [970, 90],
                ],
                "div-gpt-ad-1701945163318-0"
              )
              .addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            requestBiddingFromPWT();
          });
        } else {
          googletag.cmd.push(function () {
            googletag
              .defineSlot(
                "/1007232/Lallantop_Mobile_ROS_ATF_300x250",
                [
                  [336, 280],
                  [300, 250],
                ],
                "div-gpt-ad-1701946028239-0"
              )
              .addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            requestBiddingFromPWT();
          });
        }
        // apstag.fetchBids(
        //   {
        //     slots:
        //       size?.width < 499
        //         ? createApsSlotsRosMobile({})
        //         : createApsSlotsRosDesktop({}),
        //     timeout: 2e3,
        //   },
        //   apstagBidCallback
        // );
      }, 500);
    }
  }, [firstScroll]);

  useEffect(() => {

    if(size.width){
      
      apstag.fetchBids(
        {
          slots:
            size.width < 768
              ? createApsSlotsRosMobile({})
              : createApsSlotsRosDesktop({}),
          timeout: 2e3,
        },
        apstagBidCallback
      );
    }
   
  },[size.width])

  useEffect(() => {
    async function onFirstScroll() {
      if (!firstScroll) {
        setFirstScroll(true);
      }
    }
    function handleScroll() {
      onFirstScroll();
      window.removeEventListener("scroll", handleScroll);
    }
    window.addEventListener("scroll", handleScroll);
  }, []);

  const parseHtml = useMemo(
    () => removeHtmlTags(topicData?.entity?.articleHTML),
    [topicData?.entity?.articleHTML]
  );

  return (
    <>
      <Head>
        <meta name="keywords" content={`${topicData?.entity?.metaKeywords} `} />

        <meta name="author" content="TheLallantop"></meta>
        <meta property="fb:pages" content="1453842511589254"></meta>
        <meta
          property="article:modified_time"
          content={topicData?.entity?.updatedAt}
        ></meta>
        <meta
          property="article:published_time"
          content={topicData?.entity?.publishedAt}
        ></meta>
        <meta
          name="twitter:title"
          content={topicData?.entity?.englishTitle}
        ></meta>
        <meta
          name="twitter:image"
          content={topicData?.entity?.headingImageUrl}
        ></meta>
        <meta name="twitter:site_name" content="The Lallantop"></meta>
        <meta
          name="twitter:description"
          content={
            parseHtml && parseHtml.length > 150
              ? parseHtml.slice(0, 150)
              : parseHtml
          }
        ></meta>
        <meta
          name="twitter:url"
          content={`${process.env.NEXT_PUBLIC_AUTH_URL}topic/${topicData?.entity?.slug}`}
        ></meta>
        <script
          id="my-script-detail"
          type="application/ld+json"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org/",
              "@type": "WebPage",
              name: `${
                topicData?.entity?.englishTitle || topicName
              } Latest News, Updates in Hindi | ${
                topicData?.entity?.title
              } के समाचार और अपडेट - The Lallantop`,
              description: `${
                topicData?.entity?.englishTitle || topicName
              } News in Hindi: Get More information on ${
                topicData?.entity?.title
              } including breaking news, speech, opinion and analysis. Check News articles, photos, videos of ${
                topicData?.entity?.englishTitle || topicName
              } at The Lallantop`,
              url: `${process.env.NEXT_PUBLIC_AUTH_URL}topic/${topicData?.entity?.slug}`,
              publisher: {
                "@type": "Organization",
                name: "The Lallantop",
                url: "https://www.thelallantop.com/",
                logo: {
                  "@type": "ImageObject",
                  url: "https://www.thelallantop.com/assets/images/lallatop-logo-m.svg",
                  width: 600,
                  height: 60,
                },
              },
            }),
          }}
        ></script>
      </Head>
      <NextSeo
        canonical={`${process.env.NEXT_PUBLIC_AUTH_URL}topic/${topicData?.entity?.slug}`}
        title={`${topicData?.entity?.metaTitle} `}
        description={`${topicData?.entity?.metaDescription} `}
        datePublished={topicData?.entity?.publishedAt}
        dateModified={topicData?.entity?.updatedAt}
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_AUTH_URL}topic/${topicData?.entity?.slug}`,
          title: `${
            topicData?.entity?.englishTitle || topicName
          } Latest News, Updates in Hindi | ${
            topicData?.entity?.title
          } के समाचार और अपडेट - The Lallantop`,
          description: `${
            topicData?.entity?.englishTitle || topicName
          } News in Hindi: Get More information on ${
            topicData?.entity?.title
          } including breaking news, speech, opinion and analysis. Check News articles, photos, videos of ${
            topicData?.entity?.englishTitle || topicName
          } at The Lallantop`,
          type: "website",
          images: [
            {
              url: topicData?.entity?.headingImageUrl,
              alt: `${
                topicData?.entity?.englishTitle || topicData?.entity?.title
              } - thumbnail image`,
            },
          ],
          site_name: "The Lallantop",
        }}
        twitter={{
          handle: "@TheLallantop",
          site: "@TheLallantop",
          cardType: "summary_large_image",
        }}
        facebook={{
          appId: "574628820637757",
        }}
        robotsProps={{
          // maxSnippet: -1,
          maxImagePreview: "large",
          // maxVideoPreview: -1,
        }}
      />
      <h1 className="h1Hide">{topicData?.entity?.englishTitle}</h1>
      <div className="content-wrapper">
        <Container align="center">
          {/* Ads Container */}
          <div className="container-row py-2" align="center">
            <p
              style={{
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
              }}
            >
              Advertisement
            </p>
            <div
              id={
                size.width > 600
                  ? "div-gpt-ad-1701945163318-0"
                  : "div-gpt-ad-1701946028239-0"
              }
              style={{
                minWidth: "300px",
                minHeight: size.width > 600 ? "100px" : "260px",
                display: "block !important",
                alignContent: "center",
                textAlign: "-webkit-center",
              }}
            >
              <script
                type="text/javascript"
                dangerouslySetInnerHTML={{
                  __html:
                    size.width > 600
                      ? `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})`
                      : `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})`,
                }}
              ></script>
            </div>
          </div>
        </Container>
              {
                masterConfig['ChampionsTrophyWidget']['MainBanners'] && 
              
      <WidgetHome newsData = {cricketData}    scoreData = {scoreData} pointsData={pointsData}  table = {pointsData.standings.stage1.groups[0]} size = {size}/>
        
              }
        <Container>
          <ul className="breadcrumb">
            <li>
              <a href="/" passHref>
                <a>
                  <i className="icon-cat-home"></i>
                  <span>
                    {/* <FormattedMessage id="home" defaultMessage="होम" /> */}
                    Home
                  </span>
                </a>
              </a>
            </li>

            <li>
              <a href="/topic" passHref>
                <a>
                  <span>
                    {/* <FormattedMessage id="topic" defaultMessage="टॉपिक्स" /> */}
                    Topics
                  </span>
                </a>
              </a>
            </li>

            <li>
              <a href={`/topic/${topicData?.entity?.slug}`} passHref>
                <a>
                  <span>{topicData?.entity?.englishTitle}</span>
                </a>
              </a>
            </li>

            {/* <li>
              <a
                href={`show/all/detail/${query?.seriesSlug}/${query?.postSlug}`}
                passHref
              >
                <a>
                  <span>{query?.seriesSlug}</span>
                </a>
              </a>
            </li> */}
          </ul>

          <div className="container-row">
            <div className="card-wrapper">
              <div className="card-left">
                {topicData?.entity?.title === "राम मंदिर" ? (
                  <div className="topic-custom-container ">
                    <img
                      src={ramMandirBanner[0]?.bannerImage}
                      width="100%"
                      height="auto"
                      alt="person"
                      // style={{
                      //   minHeight: "80px",
                      //   maxHeight: "400px",
                      //   aspectRatio: "1/1",
                      // }}
                      // className="rounded-4"
                    />
                  </div>
                ) : (
                  <div
                    className="card-body columnist-detail-head mb-3 text-white"
                    style={{
                      borderRadius: "1.5rem !important",
                      padding: "2rem !important",
                      margin: "0.5rem",
                      backgroundColor: "#016369",
                    }}
                  >
                    <div
                      className="float-start"
                      style={{
                        // width: "40%",
                        marginRight: "2rem",
                      }}
                    >
                      <img
                        src={topicData?.entity?.headingImageUrl}
                        width="122px"
                        height="122px"
                        alt="person"
                        style={{
                          minHeight: "80px",
                          maxHeight: "400px",
                          aspectRatio: "1/1",
                        }}
                        className="rounded-4"
                      />
                    </div>
                    <h4 className="position-relative mb-0 topic-title">
                      {topicData?.entity?.title}
                    </h4>
                    <p className="m-0">
                      {topicData?.entity?.articleHTML && (
                        <span
                          style={{
                            textAlign: "justify",
                            WebkitLineClamp: isExpanded ? null : threshold,
                          }}
                          ref={contentRef}
                          className={isExpanded ? "" : "topic-card-clamp"}
                        >
                          {HtmlParser(topicData?.entity?.articleHTML)}
                        </span>
                      )}
                      {isClamped && (
                        <span
                          className="d-flex align-items-center"
                          type="button"
                          onClick={() => setExpanded(!isExpanded)}
                          style={{
                            height: 30,
                            justifyContent: isExpanded ? "center" : "flex-end",
                          }}
                        >
                          {isExpanded ? (
                            <span className="topic_read_more">
                              <FormattedMessage
                                id="read_less"
                                defaultMessage="कम पढ़ें"
                              />
                              <img
                                src="/assets/images/icons8-chevron-up-48.png"
                                width={18}
                                height={18}
                                style={{ marginLeft: 5 }}
                                alt="read less"
                              />
                            </span>
                          ) : (
                            <span className="topic_read_more">
                              <FormattedMessage
                                id="read_more"
                                defaultMessage="और पढ़ें"
                              />

                              <img
                                src="/assets/images/icons8-down-arrow-48.png"
                                width={18}
                                height={18}
                                style={{ marginLeft: 5 }}
                                alt="read more"
                              />
                            </span>
                          )}
                        </span>
                      )}
                    </p>
                  </div>
                )}

                <div className="card-body mb-4">
                  <div className="topic-container">
                    {topicData?.entity?.textArticles?.length > 0 && (
                      <div
                        className={`topic-tab-list ${
                          activeTab === "text" ? "active" : "inactive"
                        }`}
                        onClick={() => setActiveTab("text")}
                      >
                        Articles
                      </div>
                    )}
                    {topicData?.entity?.videoArticles?.length > 0 && (
                      <div
                        className={`topic-tab-list ${
                          activeTab === "video" ? "active" : "inactive"
                        }`}
                        onClick={() => setActiveTab("video")}
                      >
                        Videos
                      </div>
                    )}
                    {topicData?.entity?.audioArticles?.length > 0 && (
                      <div
                        className={`topic-tab-list ${
                          activeTab === "audio" ? "active" : "inactive"
                        }`}
                        onClick={() => setActiveTab("audio")}
                      >
                        Audio
                      </div>
                    )}
                    {topicData?.entity?.shortsArticles?.length > 0 && (
                      <div
                        className={`topic-tab-list ${
                          activeTab === "shorts" ? "active" : "inactive"
                        }`}
                        onClick={() => setActiveTab("shorts")}
                      >
                        Shorts
                      </div>
                    )}
                  </div>
                  <div>
                    <div>
                      <InfiniteScroll
                        dataLength={topicCategoryData[activeTab].length}
                        next={getMorePost}
                        hasMore={hasMore[activeTab]}
                        loader={<div className="lds-dual-ring"></div>}
                        // style={{ marginLeft: "-10px" }}
                        scrollThreshold={0.5}
                      >
                        {console.log(
                          "activeTab",
                          activeTab,
                          activeTab === "shorts"
                        )}
                        {activeTab === "shorts" ? (
                          <div className="d-flex flex-wrap flex-row gap-2 custom-shorts-container">
                            {topicCategoryData[activeTab]?.map((postData) => (
                              <div key={`${postData?._id}`}>
                                <a
                                  className="cursor-pointer"
                                  href={postData?.permalink}
                                >
                                  {postData && postData?.headingImageUrl && (
                                    <>
                                      <img
                                        src={
                                          postData?.headingImageUrl +
                                          "?width=200"
                                        }
                                        alt={postData?.imgAltText || "News pic"}
                                      />
                                      <div className="news-type-icon">
                                        <i
                                          style={{ color: "white" }}
                                          className="icon-play-circle"
                                        ></i>
                                      </div>
                                    </>
                                  )}
                                </a>
                              </div>
                            ))}
                          </div>
                        ) : activeTab === "audio" ? (
                          <Row className="row-cols-1">
                            {topicCategoryData[activeTab]?.map(
                              (postData, index) => (
                                <div key={index}>
                                  {" "}
                                  <a
                                    className="outer-container-audio"
                                    href={postData?.permalink?.split(".com")[1]}
                                  >
                                    <div className="img-cont">
                                      <img
                                        src={
                                          postData?.headingImageUrl +
                                          "?width=200"
                                        }
                                        layout="fill"
                                        alt={postData?.imgAltText || "News pic"}
                                      />
                                      <div className="news-type-icon">
                                        <i className="icon-mic"></i>
                                      </div>
                                    </div>

                                    <div className="right-side">
                                      <div className="title">
                                        {postData?.title}
                                      </div>
                                      <div
                                        style={{
                                          color: "gray",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        <span
                                          className="pre-span"
                                          style={{ marginRight: "100px" }}
                                        >
                                          {postData?.publishedAt
                                            ? timeSince(postData?.publishedAt)
                                            : timeSince(
                                                postData?.createdAt
                                              )}{" "}
                                          ago
                                        </span>
                                      </div>
                                    </div>
                                  </a>
                                  {/* {size.width < 500 && (
                                  <div
                                    className="line-newsImageTextBanner1 line-readNews"
                                    style={{
                                      height: "1px",
                                      background: "rgba(166, 166, 166, 0.2)",
                                      width: "100%",
                                    }}
                                  ></div>
                                )} */}
                                </div>
                              )
                            )}
                          </Row>
                        ) : (
                          <Row className="row-cols-1">
                            {topicCategoryData[activeTab]?.map((postData) => (
                              <ReadNews
                                key={postData?._id}
                                postData={postData}
                                isTopic={true}
                              />
                            ))}
                          </Row>
                        )}
                      </InfiniteScroll>
                      <NoRecordsFoundMessage
                        entities={topicCategoryData[activeTab]}
                      />
                    </div>
                  </div>
                  {/* ) : ( // <NotFound />
                  <FormattedMessage
                    id="no_hashtags_content"
                    defaultMessage="इस हैशटैग के लिए कोई आर्टिकल उपलब्ध नहीं है."
                  />
                  )} */}
                </div>
              </div>
              {adPlacement300_600.length > 0 ? (
                <div className="card-right">
                  <div className="sponser-card no-bg s-970x250">
                    <a
                      href={
                        (adPlacement300_600 &&
                          adPlacement300_600[0]?.redirect_url) ||
                        "#"
                      }
                    >
                      <img
                        src={
                          adPlacement300_600 && adPlacement300_600[0]?.image_url
                        }
                        alt="ads"
                      />
                    </a>
                  </div>
                </div>
              ) : (
                <div className="card-right">
                  {!!trendingPosts?.length > 0 && (
                    <TrendingToday data={trendingPosts} />
                  )}
                </div>
              )}
            </div>
          </div>
        </Container>
      </div>
      <FAQComponent data={topicData?.entity?.faqs} />
    </>
  );
};
export default ActiveTabs;
